<template>
  <form action>
    <div class="modal-card" style="width: 12cm">
      <header class="modal-card-head">
        <p class="modal-card-title">Project Wizzard</p>
      </header>
      <section class="modal-card-body" ref="createProjectRef">
        <div class="content">
          Welkom!
          <br />
          <br />Volg de komende stappen om een nieuw project aan te maken. Om een project aan te maken dient u alle
          stappen te hebben doorlopen. Wanneer u tussentijds wilt stoppen kan dat door op stoppen te drukken. Alle
          informatie die u hebt ingevoerd zal verloren gaan. Druk op volgende om verder te gaan.
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Stoppen</button>
        <button class="button is-primary" @click.prevent="$emit('next')">Volgende</button>
      </footer>
    </div>
  </form>
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/IntroProjectModal.vue